import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AuthorizedDeviceEnrollmentPage, { getDefaultPageData } from "components/pages/AuthorizedDeviceEnrollmentPage";
import Classes from "model";

export default function CaptureMabiFaceIDSuccess(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "mobile", "name" ], "George's IPhone")
        .update([ "mobile", "userID" ], "georgew")
        .update([ "mobile", "password" ], "12345678")
        .update([ "mobile", "isEnrolled" ], true)
        .submit();

    return <AuthorizedDeviceEnrollmentPage data={ data } />
}